import React, { useState } from "react";
import { useCart } from "../CartPage/cart-context";
import { useWantProducts } from "./want-product-context";
import { useShop } from "../LandingPage/ShopContext";
import MenuSection from "../../ui/WantMenuSection";
import WantProductDetailsModal from "../../ui/WantProductDetailsModal";

const WantMenuPage = () => {
  const { addProduct } = useCart();
  const { wantProducts, loading } = useWantProducts();
  const { shop } = useShop();

  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleAddToCart = async (product) => {
    if (!shop) {
      alert("Please select a shop first.");
      return;
    }

    const result = await addProduct(shop, product, 1);

    if (!result.success) {
      alert(result.message || "Failed to add item.");
    }
  };

  return (
    <main className="p-4 bg-gray-50 min-h-screen">

      <MenuSection
        products={wantProducts}
        loading={loading}
        onAddToCart={handleAddToCart}
        onProductClick={(product) => setSelectedProduct(product)}
      />

      <WantProductDetailsModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />

    </main>
  );
};

export default WantMenuPage;
